<div class="bg-yellow-300 text-center p-2">
  <span class="mr-4"
    >A verification email has been sent to {{ authService.user?.email }}. Please
    check your inbox,
    <span class="underline cursor-pointer" (click)="resendVerification()"
      >resend verification</span
    >
    or
    <span class="underline cursor-pointer" (click)="onEmailChangeClick.emit()"
      >change you email</span
    >.
  </span>
</div>
